var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "message-container d-flex justify-content-begin mb-2 inbound",
      attrs: { id: _vm.getId },
    },
    [
      _c("div", { staticClass: "message" }, [
        _c("div", { staticClass: "header font-weight-bold" }, [
          _c("span", { staticClass: "contact-filemaker-id" }, [
            _vm._v(
              _vm._s(_vm._f("uppercase")(_vm.getEmailContext || _vm.getEmail))
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "contact-full-name" }, [
            _vm._v(_vm._s(_vm._f("uppercase")(_vm.contactFullName))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content d-flex flex-column",
            class: { active: _vm.isHighlight },
            style: _vm.styles,
          },
          [
            _c(
              "div",
              { staticClass: "content-body w-100 d-flex flex-column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "message-subject d-flex w-100 cursor-pointer",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "wrapper w-100",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onShowBody.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("b", [_vm._v("Subject:")]),
                        _vm._v(" " + _vm._s(_vm.getSubject) + "\n            "),
                        _c("i", {
                          staticClass: "fas ml-2 mr-1",
                          class: [
                            _vm.showBody ? "fa-chevron-up" : "fa-chevron-down",
                          ],
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("message-settings", {
                      attrs: {
                        settings: _vm.emailMessageSettings,
                        message: _vm.message,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showBody
                  ? _c(
                      "div",
                      { staticClass: "w-100 mt-2" },
                      [
                        _c("iframe-loader", {
                          attrs: { url: _vm.getPreviewUrl },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer text-black-50" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("uppercase")(_vm.statusString)) +
              "\n    "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "mr-2",
        staticStyle: { "font-size": "24px", "vertical-align": "middle" },
      },
      [_c("i", { staticClass: "fas fa-envelope" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }